import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { appendTestableElementAttributes, AttachmentLink, StyledFlex } from '@dreryk/react-components';

import { useMedicalInformationAttachments } from '../shared/hooks/useMedicalInformationAttachments';

import { VisitHistoryAttachmentStatus } from './VisitHistoryAttachmentStatus';

type VisitHistoryMedicalImagingAttachmentProps = {
   readonly medicalInformationAttachments: MedicalInformationAttachment[] | undefined;
};

export const VisitHistoryMedicalImagingAttachment = (props: VisitHistoryMedicalImagingAttachmentProps): JSX.Element => {
   const medicalInformationAttachments = useMedicalInformationAttachments(props.medicalInformationAttachments);

   return (
      <StyledFlex direction={'column'} gap={4} {...appendTestableElementAttributes('attachments')}>
         {medicalInformationAttachments.map((attachment) => (
            <StyledFlex gap={8} key={attachment.id} alignItems={'center'}>
               <AttachmentLink
                  key={attachment.downloadUrl}
                  testId={attachment.id.toString()}
                  downloadUrl={attachment.downloadUrl}
                  name={attachment.name}
               />
               {attachment.removed ? <VisitHistoryAttachmentStatus /> : null}
            </StyledFlex>
         ))}
      </StyledFlex>
   );
};
